import exifr from 'exifr';
import { geoDist } from './geo';
import { trackRec } from './trackRec';

// where was a gallery photo taken? EXIF GPS first, else its capture time on a recorded tour
export async function exifInfo(file) {
  try {
    const x = await exifr.parse(file, { gps: true, pick: ['GPSLatitude', 'GPSLatitudeRef', 'GPSLongitude', 'GPSLongitudeRef', 'DateTimeOriginal', 'CreateDate', 'GPSImgDirection'] });
    if (!x) return {};
    const tm = x.DateTimeOriginal || x.CreateDate;
    return { lat: x.latitude, lon: x.longitude, time: tm instanceof Date ? tm.getTime() : null, dir: x.GPSImgDirection };
  } catch { return {}; }
}

const allTracks = (tracks) => { const r = trackRec(); return [...(tracks || []), ...(r?.pts?.length ? [r] : [])]; };

// position at time `tm` interpolated between the two neighbouring track points
export function posAtTime(tm, tracks) {
  for (const tr of allTracks(tracks)) {
    const P = (tr.pts || []).filter((p) => p.t && p.lat != null);
    if (P.length < 2 || tm < P[0].t - 120000 || tm > P[P.length - 1].t + 120000) continue;
    const i = P.findIndex((p) => p.t >= tm);
    if (i <= 0) return { lat: (i ? P[P.length - 1] : P[0]).lat, lon: (i ? P[P.length - 1] : P[0]).lon };
    const a = P[i - 1], b = P[i], f = (tm - a.t) / Math.max(1, b.t - a.t);
    return { lat: a.lat + (b.lat - a.lat) * f, lon: a.lon + (b.lon - a.lon) * f };
  }
  return null;
}

// nearest point on any tour ("put it on the path")
export function snapToTracks(lat, lon, tracks) {
  let best = null, bd = Infinity;
  allTracks(tracks).forEach((tr) => (tr.pts || []).forEach((p) => { const d = geoDist([lat, lon], [p.lat, p.lon]); if (d < bd) { bd = d; best = p; } }));
  return best ? { lat: best.lat, lon: best.lon, d: bd } : null;
}

export async function placePhoto(file, tracks) {
  const x = await exifInfo(file);
  if (x.lat != null) return { lat: x.lat, lon: x.lon, posSrc: 'exif', ...(x.time ? { takenAt: x.time } : {}), ...(x.dir != null ? { dir: x.dir, dirSrc: 'exif' } : {}) };
  const tm = x.time || file.lastModified;
  const p = tm ? posAtTime(tm, tracks) : null;
  return p ? { ...p, posSrc: 'track', takenAt: tm } : (x.time ? { takenAt: x.time } : {});
}
